import { Button, DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutUnassignPrompt extends Layout {
    buttonNo: Button;
    buttonYes: Button;
    panelButtons: Panel;
    sourceReasonCode: DataSource;
    textboxComments: Textbox;
    textboxReasonCode: Textbox;
}
